import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { molineConfig } from "./data";

export default function MolinePage() {
  return <CityPageTemplate config={molineConfig} />;
}